import {
	DELETE_GACOMPONENT_ACCOUNT,
	GET_ALL_ACCOUNTS,
	POST_GACOMPONENT_ACCOUNT,
	SET_ACCOUNTS_PARAMETERS
} from '../actiontypes';
import {gaComponentsAccountURL, getAllAccountsUrl} from '../apiUrls';

/**
 * Returns an action to be dispatched and treated by the api-middleware, ultimately making an API call through Axios.
 * Represents a request all the active components for the given engagements.
 * @param {Number} engagementId Engagement ID.
 * @returns {Object} An action object.
 */
export const getAllAccounts = (engagementId, config) => {
	const url = getAllAccountsUrl(engagementId, config);

	return {
		type: GET_ALL_ACCOUNTS,
		meta: {
			api: {
				url,
				method: 'GET'
			}
		},
		config
	};
};

export const setAccountsParameters = (payload) => {
	return {
		type: SET_ACCOUNTS_PARAMETERS,
		payload
	};
};

export const createGAComponentAccount = (engagementId, accountId, componentIds) => {
	const url = gaComponentsAccountURL(engagementId, accountId);

	return {
		type: POST_GACOMPONENT_ACCOUNT,
		meta: {
			api: {
				url,
				method: 'POST',
				data: {
					gaComponentId: [...componentIds]
				}
			}
		}
	};
};

export const deleteGAComponentAccount = (engagementId, accountId, componentId) => {
	const url = gaComponentsAccountURL(engagementId, accountId, true, componentId);

	return {
		type: DELETE_GACOMPONENT_ACCOUNT,
		meta: {
			api: {
				url,
				method: 'DELETE'
			}
		},
		accountId,
		componentId
	};
};
